import HexColorBin from './HexColorsBin'

export default HexColorBin
